/* eslint-disable camelcase */
import { legacyPage, page, simplePermission, externalApp, group, legacyTab, tab, addPermissionGroup } from './viewConfigHelpers';

export default {
    tabs: [
        tab('csc_operations_fleet', 'fleet')
            .href('#/fleet')
            .icon('globe')
            .get(),
        tab('csc_tasks', 'tasks')
            .href('#/tasks')
            .icon('tasks')
            .get(),
        tab('csc_tasks_mobile', 'tasksMobile')
            .href('#/tasks-mobile')
            .icon('tasks')
            .get(),
        tab('csc_external_tools', 'externalTools')
            .href('#/external-tools')
            .icon('wrench')
            .get(),
        tab('csc_rollout', 'rollout')
            .href('#/rollout')
            .externalApp('external_rollout_tool')
            .icon('cloud-upload')
            .get(),
        legacyTab('csc_people', 'people')
            .href('#/people/:menuitem?')
            .icon('users')
            .get(),
        tab('csc_fleet_data', 'fleetData')
            .href('#/fleet-data/:menuitem?')
            .icon('table')
            .get(),
        tab('csc_vehicle_data', 'vehicleData')
            .href('#/vehicle-data/:menuitem?')
            .icon('university')
            .get(),
        tab('rh_trips', 'rhTripsList')
            .href('#/rh-trips-list')
            .icon('taxi')
            .get(),
        tab('iamn-rh_vehicle_schedule_view', 'rhVehicleScheduleView')
            .href('#/rh-vehicle-schedule-view')
            .externalApp('rh_vehicle_schedule_view')
            .icon('calendar')
            .get(),
        tab('csc_p2p_administration', 'p2pAdministration')
            .href('#/p2p/:menuitem?')
            .icon('share-alt')
            .get(),
        tab('external_rentaride_partner_admin', 'rentaridePartnerAdmin')
            .href('#/rentaride-partner-admin')
            .externalApp('external_rentaride_partner_admin')
            .icon('motorcycle')
            .get(),
        tab('iamn-external_fuelforlife_admin', 'fuelforlifeAdmin')
            .href('#/fuelforlife')
            .externalApp('iamn-external_fuelforlife_admin')
            .icon('globe')
            .get(),
        tab('external_cslight_vehicles', 'csLightVehicles')
            .href('#/cs-vehicles/:menuitem?')
            .icon('car')
            .get(),
        tab('external_cslight_trips', 'csLightTrips')
            .href('#/cs-trips/:menuitem?')
            .icon('share-alt')
            .get(),
        tab('external_cslight_people', 'csLightPeople')
            .href('#/cs-people/:menuitem?')
            .icon('users')
            .get(),
        tab('external_cslight_service_attributes', 'csLightServiceAttributes')
            .href('#/cs-service-attributes/:menuitem?')
            .icon('sliders')
            .get(),
        tab('external_cslight_emea_administration', 'csLightAdministration')
            .href('#/cs-administration/:menuitem?')
            .icon('gears')
            .get(),
        tab('log_files_view', 'logFiles')
            .href('#/log-files')
            .externalApp('external_log_files')
            .icon('files-o')
            .get(),
        tab('external_rcv_emea_viewer', 'roadClearance')
            .href('#/road-clearance-viewer')
            .externalApp('external_rcv_emea_viewer')
            .icon('road')
            .get(),
        tab('external_cn_fapiao', 'customerRequests')
            .href('#/cn-fapiao/:menuitem?')
            .icon('weixin')
            .get(),
        tab('external_rmp', 'rmp')
            .href('#/rmp')
            .externalApp('external_rmp')
            .icon('wifi')
            .get(),
        tab('iamn-techonly_app_manage_permissions', 'techonlyAppAdmin')
            .href('#/app-manage-permissions')
            .externalApp('external_techonly_app_manage_permissions')
            .icon('television')
            .get(),
        tab('external_message_viewer_ui', 'messageViewer')
            .href('#/message-viewer')
            .externalApp('external_message_viewer')
            .icon('file-o')
            .get(),
        tab('view_vehicle_shadow', 'vehicleShadow')
            .href('#/vehicle-shadow')
            .externalApp('external_vehicle_shadow')
            .icon('wifi')
            .get(),
        legacyTab('csc_administration', 'administration')
            .href('#/administration/:menuitem?')
            .icon('gears')
            .get(),
        tab('csc_feedback', 'feedback')
            .icon('commenting')
            .options({ menuComponent: 'FeedbackPanel' })
            .get()
    ],

    menus: {
        csc_operations_fleet: [
            simplePermission('fleet_rmp', 'RMP'),
            simplePermission('fleet_vehicle_other_data', 'Additional data in vehicle details view'),
            simplePermission('fleet_vehicle_alert_list', 'Vehicle alert list'),
            simplePermission('gps_positions_all', 'All GPS positions visible'),
            simplePermission('gps_positions_not_booked', 'GPS positions not booked visible'),
            simplePermission('gps_positions_parked_in_statistic_zone', 'GPS Positions parked in zone visible'),
            simplePermission('extended_vehicle_information_no_gps', 'All vehicle information except GPS'),
            simplePermission('control_parking_behavior', 'Manually start/stop paid parking processes'),
            simplePermission('fleet_vehicle_battery_health_data', 'Low voltage battery health'),
            simplePermission('fleet_delete_relocations', 'Delete relocations'),
            simplePermission('rh_trips_manage', 'Manage RH trips'),
            simplePermission('stateless_live_data_updates', 'Stateless Live Vehicle Data')
        ],

        csc_tasks: [simplePermission('tooltask_view', 'Task View'), simplePermission('tooltask_manage', 'Task Manage')],

        csc_rollout: [
            simplePermission('assemble_csm3_stateful', 'Assemble CS3 Stateful'),
            simplePermission('assemble_csm4_stateful', 'Assemble CS4 Stateful'),
            simplePermission('assemble_csm3_stateless', 'Assemble CS3 Stateless'),

            simplePermission('rollout_techonly_infleeting_software', 'TechOnly Infleeting Software'),
            simplePermission('rollout_techonly_available_packages', 'TechOnly Available Packages'),
            simplePermission('rollout_stateless_update_api', 'Stateless Update API'),
            simplePermission('rollout_target_versions', 'Target versions'),
            simplePermission('rollout_field_test_vins', 'Field test VINs'),
            simplePermission('rollout_special_vins', 'Special VINs'),
            simplePermission('rollout_tags', '#Tags')
        ],

        csc_administration: [
            page('administration_user_preferences', 'User Preferences').get(),
            page('administration_messages', 'Messages').get(),
            page('administration_manage_notifications', 'Manage Notifications').get(),

            simplePermission('rh_trip_notifications_view', 'View RH Trip Notifications'),
            simplePermission('rh_trip_notifications_manage', 'Manage RH Trip Notifications'),

            group('Keycloak', [
                externalApp('iamnext_groups_view', 'Group Management'),
                externalApp('iamnext_permissions_view', 'Permission Management'),
                externalApp('iamnext_users_view', 'User Management')
            ]),

            group('Tasks', [
                page('administration_alert_settings', 'Configuration').get(),
                page('administration_alert_notifications', 'My Notifications').get()
            ])
        ],

        csc_people: [
            simplePermission('external_odm_access_control_manage', 'Manage ODM Access Control'),
            simplePermission('external_odm_member_ces', 'CES Member Manage'),
            simplePermission('people_driver_supply_plan_driver_vendor', 'Supply plan view for driver vendor'),
            simplePermission('people_driver_supply_plan_driver_manager', 'Supply plan view for driver manager'),

            group('Drivers', [
                externalApp('external_driver_cn_core', 'Core data'),
                legacyPage('people_driver_supply_plan', 'Supply plan')
                    .template('components/people/drivers/supplyPlan/supplyPlan.html')
                    .get()
            ]),

            group('Member', [
                externalApp('external_people_odm_customer_mgmt', 'ODM Users (EMEA)'),

                // Permissions for external apps
                simplePermission('member_view', 'Member view'),
                simplePermission('member_manage', 'Member view manage'),
                simplePermission('driver_view', 'Driver view'),
                simplePermission('driver_manage', 'Driver view manage'),
                simplePermission('member_invoices_view', 'Invoice view'),
                simplePermission('member_invoice_manage', 'Invoice view manage'),
                simplePermission('member_coupons_view', 'Coupon view'),
                simplePermission('member_coupons_manage', 'Coupon view manage'),
                simplePermission('supply_plan_upload', 'Supply plan upload'),
                simplePermission('driver_shifts', 'Driver shift view'),
                simplePermission('emea_profiles', 'EMEA Users'),
                simplePermission('emea_profiles_private', 'EMEA Users Private'),
                simplePermission('cn_profiles', 'CN Users'),
                simplePermission('cn_profiles_private', 'CN Users Private'),
                simplePermission('emea_p2p_es_owner', 'P2P ES Owner'),
                simplePermission('emea_p2p_es_peer', 'P2P ES Peer'),
                simplePermission('emea_p2p_es_dealer', 'P2P ES Dealer'),
                simplePermission('cn_rh_ctu_member', 'RH CTU Member Core'),
                simplePermission('cn_rh_ctu_member_private', 'RH CTU Member Private'),
                simplePermission('cn_rh_ctu_b2b', 'RH CTU B2B'),
                simplePermission('cn_rh_ctu_b2b_private', 'RH CTU B2B Private'),
                simplePermission('cn_rh_ctu_driver', 'RH CTU Driver Core'),
                simplePermission('cn_rh_ctu_driver_private', 'RH CTU Driver Private'),
                simplePermission('external_urban_pilot_users_view', 'Urban Pilot Users view'),
                simplePermission('external_urban_pilot_users_manage', 'Urban Pilot Users manage'),

                externalApp('iamn-external_cust_data_export', 'CUST data export')
            ])
        ],

        csc_p2p_administration: [page('p2p_administration', 'P2P Administration').get()],

        csc_fleet_data: [
            addPermissionGroup('external_fleet_data_operator', 'Operator Administration', [
                'external_fleet_data_operator',
                'external_fleet_data_operator_read'
            ]),
            addPermissionGroup('external_fleet_data_subsidiary', 'Subsidiary Administration', [
                'external_fleet_data_subsidiary',
                'external_fleet_data_subsidiary_read'
            ]),
            addPermissionGroup('external_fleet_data_fleet', 'Fleet Administration', [
                'external_fleet_data_fleet',
                'external_fleet_data_fleet_read'
            ]),
            page('administration_fleets_view', 'Fleet Configuration').get(),
            simplePermission('administration_fleets_create', 'Fleets Create'),
            simplePermission('administration_fleets_update_delete', 'Fleets Update & Delete'),
            simplePermission('fleet_master_admin', 'Fleet Master Admin'),
            page('fleet_data_vehicle_access_location_view', 'Manage Vehicle Access Locations (Pickup Dropoff)').get()
        ],

        csc_vehicle_data: [
            addPermissionGroup('external_vehicle_data', 'Core Data', [
                'external_vehicle_data',
                'external_vehicle_data_fleetmgmt',
                'iamn-external_vehicle_data_fleetmgmtext',
                'external_vehicle_data_read'
            ]),
            page('administration_vehicle_display_view', 'Displayed Data').get(),
            externalApp('external_vehicle_billing_data', 'Vehicle Billing Data'),
            // Permissions for external apps
            simplePermission('vehicle_view', 'Vehicle view'),
            simplePermission('vehicle_manage', 'Vehicle view manage'),
            simplePermission('administration_vehicle_display_manage', 'Displayed Data manage')
        ],

        external_cslight_vehicles: [
            externalApp('external_cslight_emea_vehicle_data', 'CS - Vehicle Data'),
            externalApp('external_cslight_emea_vehicle_groups', 'CS - Vehicle Groups'),
            externalApp('external_cslight_emea_damage_management', 'CS - Damage Management')
        ],
        external_cslight_trips: [
            externalApp('external_cslight_emea_calender', 'CS - Trip Calendar'),
            externalApp('external_cslight_emea_trip_report', 'CS - Trip Report'),
            externalApp('external_cslight_emea_summary', 'CS - Summary'),
            externalApp('iamn-external_cslight_trips_logbook', 'CS - Logbook')
        ],
        external_cslight_people: [externalApp('external_cslight_emea_drivers', 'CS - Drivers')],
        external_cslight_service_attributes: [
            externalApp('external_cslight_emea_stations', 'CS - Stations'),
            externalApp('external_cslight_emea_trip_parameter', 'CS - Trip-parameters'),
            externalApp('external_cslight_emea_tariffs', 'CS - Tariffs')
        ],
        external_cslight_emea_administration: [externalApp('external_cslight_emea_operators', 'CS - Operators')],
        log_files_view: [
            simplePermission('log_files_write_csm3_manual', 'Log Files write CSM3 manual'),
            simplePermission('log_files_read_csm3_manual', 'Log Files read CSM3 manual'),
            simplePermission('log_files_read_csm3', 'Log Files read CSM3'),
            simplePermission('log_files_read_csm4', 'Log Files read CSM4'),
            simplePermission('log_files_read_csm4r', 'Log Files read CSM4R'),
            simplePermission('log_files_read_csm5', 'Log Files read CSM5'),
            simplePermission('log_files_read_demoapp_techonly_ios', 'Log Files read App iOS'),
            simplePermission('log_files_read_demoapp_techonly_android', 'Log Files read App Android')
        ],
        external_rcv_emea_viewer: [simplePermission('external_rcv_emea_editor', 'Road Clearance Viewer Edit')],
        external_cn_fapiao: [
            group('Customer requests', [
                externalApp('external_cn_fapiao_overview', 'Fapiaos'),
                externalApp('external_cn_fapiao_complaints', 'Complaints')
            ])
        ],
        external_rmp: [
            simplePermission('external_rmp_low_security_commands', 'Low Security Commands'),
            simplePermission('external_rmp_mid_security_commands', 'Mid Security Commands'),
            simplePermission('external_rmp_high_security_commands', 'High Security Commands'),
            simplePermission('external_rmp_bulk_commands', 'Bulk Commands')
        ],
        teleop: [
            simplePermission('teleop_tasks_view', 'Tasks View'),
            simplePermission('teleop_tasks_manage', 'Tasks Manage'),
            group('Tasks', [externalApp('teleop_tasks_ongoing', 'Ongoing Tasks'), externalApp('teleop_tasks_archive', 'Tasks Archive')]),
            group('Sessions', [
                externalApp('teleop_sessions_ongoing', 'Ongoing Sessions'),
                externalApp('teleop_sessions_archive', 'Sessions Archive')
            ])
        ]
    },

    // Views that are neither tabs nor have submenus
    additional: [
        simplePermission('csc_calendar', 'Incidents'),
        simplePermission('csc_fuel_truck_pilot', 'Fuel truck pilot (Mobile Cockpit)'),
        simplePermission('csc_onsite_agent', 'On-site agent (Mobile Cockpit)'),
        simplePermission('csc_odm', 'Vehicle position app (deprecated)'),
        simplePermission('csc_access_admin_security_audit', 'Access Admin Security Audit'),
        simplePermission('csc_access_security_audit_view', 'Access Security Audit View'),
        simplePermission('csc_access_security_audit_report', 'Access Security Audit Report')
    ]
};
